import { Features } from 'generated/featureDefinitions'

interface FeatureAvailability {
  id: string
  available: boolean
}

export const allProjectFeatures = Object.values(Features).filter((feature) =>
  feature.startsWith('projects_')
)

const excludedFeatures = [
  Features.projects_management,
  Features.projects_with_subprojects,
  Features.projects_flexible_tracking,
]

export const isProjectBusiness = (featureAvailabilities: FeatureAvailability[]): boolean => {
  const featuresToCheck = allProjectFeatures.filter(
    (feature) => !excludedFeatures.includes(feature)
  )

  const hasAllAdvancedFeatures = featuresToCheck.every((featureId) => {
    const feature = featureAvailabilities.find((f) => f.id === featureId)
    return feature?.available === true
  })

  return !hasAllAdvancedFeatures
}
